import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import LanyardDisplay from "../../src/blocks/Components/Lanyard/Lanyard.jsx";
import ScrollReveal from "../../src/blocks/TextAnimations/ScrollReveal/ScrollReveal.jsx";

export default function TeamMemberLanyard({ person, index }) {
  const ref = useRef();
  const inView = useInView(ref, { triggerOnce: true, threshold: 0.5 });

  return (
    <div
      ref={ref}
      style={{
        minHeight: "100vh",
        width: "100vw",
        overflow: "hidden",
        background: "#000",
        color: "white",
        display: "flex",
        flexDirection: window.innerWidth < 768 ? "column" : "row",
        alignItems: "center",
        justifyContent: "center",
        padding: "5vh 5vw",
        gap: window.innerWidth < 768 ? "1rem" : "4vw",
        scrollSnapAlign: "start",
        textAlign: window.innerWidth < 768 ? "center" : "left",
        flexWrap: "wrap"
      }}
    >
      {/* Lanyard drop in from top */}
      <motion.div
        initial={{ y: "-100vh", opacity: 0 }}
        animate={inView ? { y: 0, opacity: 1 } : {}}
        transition={{ duration: 0.7, delay: index * 0.2 }}
        style={{
          flex: "0 0 40%",
          height: "80vh",
          paddingBottom: "100px",
        }}
      >
        <LanyardDisplay modelPath={person.model} scale={2} />
      </motion.div>

      <div
        style={{
          flex: "0 0 50%",
          textAlign: "left",
          paddingBottom: "100px",
          maxWidth: "700px",
          paddingLeft: window.innerWidth < 768 ? "20px" : "0",
          paddingRight: window.innerWidth < 768 ? "20px" : "90px",
          boxSizing: "border-box",
        }}
      >
        <div style={{ fontWeight: "600", fontSize: "0.9rem", color: "#aaa", marginBottom: "0.5rem" }}>
            {person.role}
          </div>
        <ScrollReveal
          baseOpacity={0}
          enableBlur={true}
          baseRotation={3}
          blurStrength={8}
        >
          
          {person.about}
        </ScrollReveal>
      </div>
    </div>
  );
}
